import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import config from "../config";

export default {
	install(Vue) {
		Vue.use(Loading);

		Vue.prototype.$vsloading = function loading(configs = {}) {
			let loaderType = "VsLoaderSpinner";
			let container = null;

			switch (configs.type) {
				case "spinner":
					loaderType = "VsLoaderSpinner";
					break;

				default:
					break;
			}

			if (configs.container) {
				container = document.querySelector(configs.container);
			} else if (config.loadingConfigs.container) {
				container = document.querySelector(
					config.loadingConfigs.container
				);
			}

			const loader = Vue.$loading.show(
				{
					// Pass props by their camelCased names
					isFullPage: false,
					color: "#000000",
					loader: "spinner",
					backgroundColor: "#28c76f",
					opacity: 0,
					width: 64,
					height: 64,
					...config.loadingConfigs,
					...configs,
					container
				},
				{
					// Pass slots by their names
					default: loaderType ? this.$createElement(loaderType) : null
				}
			);

			return loader;
		};
	}
};
